import React from 'react'
import styles from './mentionsLegales.module.scss'
import { Helmet } from 'react-helmet'

function LegalNotice() {
  return (
    <>
      <Helmet>
        <title>Mentions légales</title>
        <meta name='robots' content='follow' />
      </Helmet>

      <div className='fadinAnimation'>
        <h2 className='titlePage'>Mentions légales</h2>
        <div className={styles.content}>
          <h2>Editeur</h2>
          <br />
          <strong>LAGUINDAWS</strong> est exploité par LAGUINDA, une entreprise
          enregistrée en Guinée. <br />
          <br />
          LAGUINDA
          <br />
          RCCM : GN.TCC.2025.A.01098
          <br /> Matoto, Conakry
          <br />
          Numéro de téléphone : +224 611 36 23 65
          <br />
          <br />
          <br />
          <h2>Directeur de la publication</h2>
          <br />
          Monsieur Camara Aboubacar, Directeur général et CEO
          <br />
          <br />
          <br />
          <h2>Hébergeur</h2>
          <br />
          Le site www.laguindaws.com est hébergé par LWS (www.lws.fr - Ligne Web
          Services)
          <br />
          <br />
          10, RUE PENTHIEVRE 75008 PARIS FRANCE
          <br />
          <br />
          Téléphone : +33 1 77 62 30 03 <br />
          Contact : https://www.lws.fr/contact_formulaire.php
          <br />
          <br />
          SIRET : 85199368300024 <br />
          TVA Intracommunautaire : FR21851993683 <br />
          Code APE : 6311 Z
          <br />
          <br />
          Pour toute question ou préoccupation, veuillez nous contacter à
          l'adresse contact@laguindaws.com
          <br />
          <br />
          Merci d'utiliser <strong>laguindaws.com</strong>
        </div>
      </div>
    </>
  )
}

export default LegalNotice
